import type { Env } from '../../context/env-context';
import { ApiService } from '../../types/api';
import { SettingsApi, type SettingsApiContract } from './settings';
import type { ShopData } from './types';

export interface SiteApiContract {
  env(siteId: string, siteEnv: string): Promise<Env>;
  shop(siteId: string, siteEnv: string): Promise<ShopData>;
  settings(): SettingsApiContract;
}

declare module '../../context/page-context' {
  interface Apis {
    site: SiteApiContract;
  }
}

export class SiteApi extends ApiService implements SiteApiContract {
  public env(siteId: string, siteEnv: string): Promise<Env> {
    return this.api.fetch<Env>({
      method: 'GET',
      path: `/${siteId}/${siteEnv}`,
    });
  }

  public shop(siteId: string, siteEnv: string): Promise<ShopData> {
    return this.api.fetch<ShopData>({
      method: 'GET',
      path: `/${siteId}/${siteEnv}/shopify/shop`,
    });
  }

  public settings(): SettingsApiContract {
    return new SettingsApi(this.api);
  }
}
